// Copyright 2025, University of Maryland, All Rights Reserved
import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { MetricsDashboard } from './components/MetricsDashboard'
import type { MetricsComponentProps } from './types'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

/**
 * Main Metrics Component - tracks document processing volume for ROI estimation
 */
export const MetricsComponent: React.FC<MetricsComponentProps> = ({
  api_instance,
  organization_id,
  workspace_id,
  default_view,
  is_admin,
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <MetricsDashboard
        api_instance={api_instance}
        organization_id={organization_id}
        workspace_id={workspace_id}
        default_view={default_view}
        is_admin={is_admin}
      />
    </QueryClientProvider>
  )
}
